import { FC } from 'react';

import { AccountPlans } from '@bpm-web-app/components/src/lib/supreme-account/plans/plans';
import { AccountPageProps } from '@bpm-web-app/components/src/lib/supreme-account/account';

export const AvailablePlansPage: FC<AccountPageProps> = (props) => <AccountPlans {...props} />;

export default AvailablePlansPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'Available Plans',
        },
    };
}
